/**
 * 日付関連のutilクラス。
 */
export class DateUtils {

	/**
	 * 8桁の日付文字列をyyyy/mm/ddの表記に変換する。
	 * 
	 * @param date 
	 * @returns 
	 */
	static formatDate(date?: string) {
		if (date == undefined) {
			return '';
		} else if (date.length != 'yyyymmdd'.length) {
			return date;
		}
		return date.substr(0, 4) + '/' + date.substr(4, 2) + '/' + date.substr(6, 2);
	}

	/**
	 * 14桁の日時文字列をyyyy/mm/dd hh:mmの表記に変換する。
	 * 
	 * @param dateTime 
	 * @returns 
	 */
	static formatDateTime(dateTime?: string) {
		if (dateTime == undefined) {
			return '';
		} else if (dateTime.length != 'yyyymmddhhmmss'.length) {
			return dateTime;
		}
		return dateTime.substr(0, 4) + '/' + dateTime.substr(4, 2) + '/' + dateTime.substr(6, 2) + ' '
			+ dateTime.substr(8, 2) + ':' + dateTime.substr(10, 2);

	}

	/**
	 * Date型の日時をyyyymmdd表記に変換する。
	 * 
	 * @param date 
	 * @returns 
	 */

	static formatDateToString(date:Date) {
		const yyyy = date.getFullYear();
		const mm = ('00' + (date.getMonth()+1)).slice(-2);
		const dd = ('00' + date.getDate()).slice(-2);
	  
		return `${yyyy}${mm}${dd}`;
	  }
	  
}